import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsightKind = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 329 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Mask group",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_0_14",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 329,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 1243",
				width: 329,
				height: 24,
				fill: "var(--fill-0, #D9D9D9)"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_0_14)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M2 2C18.25 2 18.25 22 34.5 22C50.75 22 50.75 2 66.9975 2C83.245 2 83.2475 22 99.495 22C115.743 22 115.745 2 131.992 2C148.24 2 148.242 22 164.492 22C180.742 22 180.74 2 196.99 2C213.24 2 213.24 22 229.49 22C245.74 22 245.742 2 261.992 2C278.242 2 278.245 22 294.497 22C310.75 22 310.747 2 327 2",
				stroke: "var(--stroke-0, #50E3C2)",
				strokeWidth: 3,
				strokeLinecap: "round"
			})
		})]
	})
});
export default SvgInsightKind;
